import { Aggregator, Column } from 'angular-slickgrid';
import { AnyHandler, AggregatorTotalsHandler } from 'src/app/types/@types/sl-v-types';
import { SLAggregator } from './slaggregator';

export class FirstAggregator extends SLAggregator {
	protected _name = 'first';
	protected _label = 'First';
	protected requiresNumber = false;
	constructor() {
		super();
	}
	init() {
		super.init();
	}
	Accumulate(item: any, column: Column<any>) {
		if (this._value[column.id] === undefined) {
			this._value[column.id] = item[column.id];
		}
	}
	SetTotals(totals: any, completeHandler?: AggregatorTotalsHandler) {
		super.SetTotals(totals);
		this.EndAggregation(totals, completeHandler);
	}
}